module.exports = __webpack_public_path__ + "static/media/CardCompPLO5Green.901823e1.png";